{{ "checkins_new_label" | localize }}
